// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, "\n.uil[data-v-1afb63c2]:before {\n  font-size: var(--1afb63c2-width);\n  vertical-align: middle;\n  font-weight: var(--1afb63c2-weight);\n}\n.uil[data-v-1afb63c2] {\n  padding-right: var(--1afb63c2-right);\n}\n", ""]);
// Exports
export default ___CSS_LOADER_EXPORT___;
